import ErrorTypeDTO from "../interface/ErrorType";

export const ErrorTypesContainer: Array<ErrorTypeDTO> = [];
